import { gql } from '@apollo/client'
import { PAGING_WITH_COUNT as PAGING } from 'requests/fragments/paging'
import { PICTURES_LIST } from 'requests/fragments/picture'
import { ROLE } from 'requests/fragments/role'

export const GET_PROFILE_ORGANIZATIONS = gql`
  query getProfile {
    me {
      id
      organizations {
        organization {
          id
          name
          code
          picture {
            ...PicturesList
          }
        }
        role {
          ...Role
        }
        status
      }
    }
  }
  ${ROLE}
  ${PICTURES_LIST}
`

export const GET_PAGINATED_ORGANIZATIONS = gql`
  query listOrganizations($filters: OrganizationFilter, $paging: PagingInput, $sort: [OrganizationsSort]) {
    paginated: paginatedOrganizations(filter: $filters, paging: $paging, sort: $sort) {
      items {
        id
        name
        picture {
          ...PicturesList
        }
        forInternalTesting
        contracts {
          id
          contractType
          currentLabel
          status
        }
      }
      paging {
        ...Paging
      }
    }
  }
  ${PICTURES_LIST}
  ${PAGING}
`

export const GET_MY_PAGINATED_ORGANIZATIONS = gql`
  query listOrganizations($filters: OrganizationFilter, $paging: PagingInput, $sort: [OrganizationsSort]) {
    paginated: myPaginatedOrganizations(filter: $filters, paging: $paging, sort: $sort) {
      items {
        id
        name
        picture {
          ...PicturesList
        }
        contracts {
          id
          contractType
          currentLabel
          status
        }
      }
      paging {
        ...Paging
      }
    }
  }
  ${PICTURES_LIST}
  ${PAGING}
`
